import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getAwardProofsByOwnerOptions } from '@/module/Author/Award/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface AwardOwnerProofListProps {
  awardId: Id;
  userId: Id;
}

export function AwardOwnerProofList({ awardId, userId }: AwardOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getAwardProofsByOwnerOptions(awardId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="award"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
